import Accordion from '@/common/components/Accordion';
import Spinner from '@/common/components/Spinner';
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { CircleChevronDownIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UpdateFeesConfigurationsModal } from '../../Update/components/UpdateFeesConfigurationsModal';
import { specialFeeApplicationMode } from '../../Update/constants/specialFeeApplicationMode.constant';

const FeesConfigurationsSection = ({ establishmentCompany }: { establishmentCompany?: EstablishmentCompanyData }) => {
  const { id } = useParams();

  const [displayFetching, setDisplayFetching] = useState(false);

  const isMutating = useIsMutating();
  const isFetching = useIsFetching({ queryKey: ['establishmentCompany', id] })

  useEffect(() => {
    isMutating && setDisplayFetching(true)
  }, [isMutating]);

  useEffect(() => {
    !isFetching && setDisplayFetching(false)
  }, [isFetching]);

  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateFeesConfigurationsModal
              establishmentCompany={establishmentCompany}
              isFetching={displayFetching && !!isFetching}
            />
          </div>

          <p className='text-xl'>
            Configurações de tarifas
          </p>

          {displayFetching && !!isFetching && <Spinner className='fill-white-400 size-4' />}
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={(
        <div className='flex flex-col gap-4'>
          <div className='flex items-center gap-3'>
            <p>
              Modo de aplicação da tarifa especial:
            </p>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />

              <p className='text-white-800'>
                {establishmentCompany?.special_fee_application_mode
                  ? specialFeeApplicationMode[establishmentCompany?.special_fee_application_mode]
                  : '--'}
              </p>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default FeesConfigurationsSection;
